var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.97671C15 3.79439 14.93 3.61207 14.79 3.48585L12.494 1.19985C12.214 0.933383 11.78 0.933383 11.5 1.19985L9.218 3.48585L1.21 11.5079C1.084 11.6341 1 11.8164 1 11.9987V14.2988C1 14.6915 1.308 15 1.7 15H3.982C4.164 15 4.346 14.9299 4.472 14.7896L12.48 6.76759L14.776 4.46757C14.902 4.34135 14.986 4.15903 14.986 3.97671H15ZM3.688 13.6116H2.4V12.2933L9.722 4.97245L11.024 6.27673L3.688 13.6116ZM12.004 5.28099L10.702 3.97671L12.004 2.67243L13.306 3.97671L12.004 5.28099Z",
    fill: "#F7B84B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.dbbf832cdb722b7525b37b4ff1af38f5.svg";
export { ForwardRef as ReactComponent };